/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import React, { useEffect, useState } from 'react';
import { Acknowledgement } from '../Acknowledgement';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import Button from 'react-bootstrap/Button';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { ItemSpecVenusWidget } from '@/widgets/item-spec-venus-widget-react';
import { ChannelPage } from '@/widgets/channel-page-widget-react';
import * as S from './styles';
import { RightContainer } from '../RightContainer';
import { getWidgetData } from '../CsmeWidgetData';
import { USER_LEVEL } from '@/config/userManagement.config';
import { vappContainer } from '@/application';
import { ApplicationFormPageService } from '../../services';
import { Loader } from '@/components';
import { Col, Row } from 'react-bootstrap';
import { FontSlider } from '../FontSlider';
import toast from 'react-hot-toast';

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

interface ICsmeFormData {
  fields: any[];
  lay: any;
  dynamicLayout?: any[];
  previewLabel?: string;
  csmeSubLabel1?: string;
  csmeSubLabel2?: string;
  progressBarSteps?: string[];
  validatorConfig?: any;

  successIcon?: string;
  errorIcon?: string;

  userFormFields: any[];
  userFormLayout: any[];
  userFormTitle: string;
}

export const RoeWPForm = ({
  roeFormData,
  onsave,
  acknowledgement,
  onAcknowledgement,
  onGoBack,
  onCloseClick,
  roeLabel,
  onNewroeNext,
  spinner,
  loading,
  _initialData,
  onDraftSave,
  currentStep,
  draftData,
  whoami,
  onFormSubmit,
  stepChange,
  csmePreviewSubLabel1,
  employeeAppliesApplicant,
  proceedInvite,
  setProceedToInvite,
  csmePreviewSubLabel2,
  csmeAppPageState,
  onPayClick,
  rendersave,
  setEmployeeApplies,
  onUserDetailsSubmit,
  rightBlockContent,
  _changeTouchStatus,
  _changeCurrStep,
  touchedStatus,
  changeStepHasError,
  applicationNo,
  type,
  onContinueClick,
  fontScale,
  updateFontScale,

  onProceedToInvite,
}: {
  onsave?: any;
  rightBlockContent?: any;
  roeLabel: string;
  whoami?: string;
  currentStep?: number;
  rendersave?: boolean;
  roeFormData: ICsmeFormData;
  acknowledgement: any;
  onAcknowledgement?(data: any, type: string): void;
  onGoBack?(): void;
  applicationNo?: string;
  fontScale: number;
  updateFontScale?(font: number): void;

  stepChange?(step: number, existingFormData: any): void;
  onCloseClick(): void;
  onNewroeNext?(formData: any): void;
  spinner?: any;
  loading?: any;
  touchedStatus?: any;
  _initialData?: any;
  onFormSubmit?(formData: any): void;
  setEmployeeApplies?(val: any): void;
  setProceedToInvite?(val: any): void;
  onPayClick?(appNo: string): void;
  onDraftSave?: any;
  draftData?: any;
  employeeAppliesApplicant?: boolean;
  proceedInvite?: boolean;
  csmePreviewSubLabel1?: string;
  _changeTouchStatus?(val: any): void;
  _changeCurrStep?(val: any): void;
  csmePreviewSubLabel2?: string;
  csmeAppPageState?: any;
  changeStepHasError?(err: any): void;
  onUserDetailsSubmit?(formData: any): void;
  type: string;
  onContinueClick?: any;
  onProceedToInvite?: any;
}) => {
  const {
    fields,
    lay,
    dynamicLayout,
    previewLabel,
    csmeSubLabel1,
    csmeSubLabel2,

    errorIcon,
    successIcon,

    userFormFields,
    userFormLayout,
    userFormTitle,
    validatorConfig,
  } = roeFormData;
  console.log('roe-->', lay);
  const layout = lay;
  console.log('entered csmeform', _initialData);
  const [stepHasError, setStepHasError] = useState<any>({});
  const [touched, setTouched] = useState<any>({});
  const [formFields, setFormFields] = useState([]);
  const [formlayout, setFormLayout] = useState(layout[1]);
  const [stateLayout, setStateLayout] = useState(layout);

  const [lookUpFields, setLookUpFields] = useState({});
  const [proceedToInvite, setproceedToInvite] = useState(
    proceedInvite ?? false
  );
  const [employeeApplicant, setemployeeApplicant] = useState(
    employeeAppliesApplicant ?? false
  );
  const [totalSteps, settotalSteps] = useState(
    (employeeApplicant ? 2 : proceedToInvite ? 1 : 1) + 2
  );
  let totsteps =
    whoami === 'prospective_employee'
      ? 1
      : (employeeApplicant ? 2 : proceedToInvite ? 1 : 1) + 2;

  let invitebool = proceedToInvite;
  let applicantbool = employeeApplicant;

  const [tempkey, setTempkey] = useState('first');

  // useEffect(() => {
  //   settotalSteps(4);
  // }, [whoami]);
  const [activeStep, setActiveStep] = useState(
    currentStep ?? 0
    // totalStep+1
  );
  console.log('oe***--->jramworkPermitA-->states', currentStep, totalSteps);

  const [dynamicKey, setdynamicKey] = useState('first');
  const [tempKey, settempKey] = useState('');
  useEffect(() => {
    setActiveStep(currentStep ?? 0);
  }, [currentStep]);

  const [subStep, setSubStep] = useState(activeStep >= 2 ? 2 : 0);
  const [initialData, setinitialData] = useState(
    _initialData && Object.entries(_initialData)?.length > 0
      ? _initialData
      : draftData?.data ?? {}
  );
  const [key, setkey] = useState('');
  useEffect(() => {
    if (spinner?.show === false && spinner?.status === 'success') {
      console.log(`on acknowledgemnt`);
      // setActiveStep(activeStep + 1);
    }
  }, [spinner]);
  useEffect(() => {
    setTimeout(() => {
      setinitialData({ ...initialData, i: 0 });
    }, 3000);
  }, []);
  // useEffect(()=>console.log("jramsteps->tot",totalSteps,activeStep))
  const _renderSubmitButton = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            justifyContent: 'space-evenly',
          }}
        >
          <Button
            variant="primary"
            size="sm"
            className="ms-3"
            type="submit"
            style={{
              display: 'inline-block',
              outline: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              lineHeight: '20px',
              fontWeight: '600',
              borderRadius: '8px',
              padding: '14px 24px',
              border: 'none',
              marginTop: '1.5rem',
              background: 'linear-gradient(to bottom right,#2f78d1,#104382)',
              color: '#fff',
            }}
            onClick={() => {
              // onProceedToInvite && onProceedToInvite();
              invitebool = true;
              applicantbool = false;
              setproceedToInvite(true);
              setemployeeApplicant(false);
            }}
          >
            Proceed with Invite
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="ms-3"
            type="submit"
            style={{
              display: 'inline-block',
              outline: 'none',
              cursor: 'pointer',
              marginTop: '1.5rem',
              fontSize: '16px',
              lineHeight: '20px',
              fontWeight: '600',
              borderRadius: '8px',
              padding: '14px 24px',
              border: 'none',
              background: 'linear-gradient(to bottom right,#2f78d1,#104382)',
              color: '#fff',
            }}
            onClick={() => {
              // onContinueClick && onContinueClick();
              applicantbool = true;
              invitebool = false;
              setemployeeApplicant(true);
              setproceedToInvite(false);
            }}
          >
            Continue with applicant form
          </Button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (_initialData && Object.entries(_initialData)?.length > 0) {
      // generateInitLayout(_initialData);
      console.log('io-> ::', _initialData);
      setinitialData(_initialData);
      setkey(key + 'hi');
    } else if (draftData?.data) {
      console.log('io-> ::', draftData?.data);
      setkey(key + 'hi->');
      setinitialData(draftData?.data);
      // generateInitLayout(draftData?.data);
    }
  }, [draftData?.data, _initialData]);

  useEffect(() => {
    console.log('iuy->', activeStep);
    setFormFields(fields[activeStep >= 1 ? 0 : activeStep]);
    window.scrollTo(0, 0);
  }, [activeStep]);
  useEffect(() => console.log('initialDataintoe', initialData));
  const _renderHeader = (isPreview: boolean) => {
    console.log(`Preview label bla:`, isPreview);
    return (
      <div className="mt-2">
        {isPreview && (
          <h3 className="text-uppercase text-center">{previewLabel}</h3>
        )}
        <h4 className="text-center">{roeLabel}</h4>
        <h6 className="text-center">
          {isPreview
            ? subStep >= 1
              ? csmePreviewSubLabel2
              : csmePreviewSubLabel1
            : activeStep >= 1 && activeStep < 2
            ? csmeSubLabel2
            : csmeSubLabel1}
        </h6>
      </div>
    );
  };

  useEffect(() => {
    setdynamicKey('first');
  }, [activeStep]);
  console.log('iob->', initialData);

  const changeTouchStatus = (data: any, key: string) => {
    setTouched({ ...touched, [`${activeStep}-${dynamicKey}`]: true });

    console.log('pok->', tempKey, dynamicKey);
    settempKey(key);
  };

  useEffect(() => {
    if (touched[`${activeStep}-${dynamicKey}`]) {
      console.log('pok->', tempKey, dynamicKey);
      setdynamicKey(tempKey);
    }
  }, [touched]);

  const updateCityHelper = async () => {
    console.log('iuwadahefywe', initialData);
    let all: any = {};
    let currFields = fields[activeStep >= 1 ? 0 : activeStep];
    if (initialData['parish'] && tempKey !== 'second' && tempKey !== 'third') {
      currFields = await updateCityParish(
        'parish',
        initialData['parish'],
        currFields
      );
    }

    if (
      initialData['selfParish'] &&
      tempKey === 'second' &&
      initialData['employmentStatus'] === 'SELF_EMPLOYED'
    ) {
      currFields = await updateCityParish(
        'selfParish',
        initialData['selfParish'],
        currFields
      );
    }

    if (
      initialData['employedParish'] &&
      tempKey === 'second' &&
      initialData['employmentStatus'] === 'EMPLOYED'
    ) {
      let temp = await updateCityParish(
        'employedParish',
        initialData['employedParish'],
        currFields
      );
      currFields = temp;
    }
    console.log(
      'ph->',
      currFields?.filter((item: any) => item?.compProps?.id === 'qualification')
    );
    console.log('all->', all);
    setFormFields(currFields);
  };
  useEffect(() => {
    updateCityHelper();
  }, [tempKey, dynamicKey]);
  useEffect(() => {
    console.log(
      'mast->',
      formFields?.filter((item: any) => item?.compProps?.id === 'qualification')
    );
  }, [formFields]);
  const cityCall = async (id: any, payload: any) => {
    const res = await getSrv().agent.getCities(payload);
    return res;
  };
  const updateCityParish = async (id: any, payload: any, formlayout: any) => {
    console.log(`updateInitialData :`, id, payload, formlayout);
    console.log('typo->', type);
    if (
      id === 'parish' ||
      id === 'selfParish' ||
      id === 'employedParish' ||
      id === 'qualification' ||
      payload?.id === 'qualification'
    ) {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const actualPayload = payload?.payload ?? payload;
      const _response = await getSrv().agent.getCities(actualPayload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        console.log(`8-> :: #3 ;`, formFields);
        let _fields: any = formlayout.map((item: any, index: number) => {
          console.log('86->', payload, item, _response.cities);
          if (
            ((payload?.id === 'qualification' && payload?.subId === 'parish') ||
              initialData?.['qualification']?.[0]?.parish === actualPayload) &&
            item?.compProps?.id === 'qualification'
          ) {
            console.log('reached-->', item?.compProps?.id);
            console.log('86->hi->', actualPayload, payload?.payload, payload);
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                attributeForm: {
                  ...item?.compProps?.attributeForm,
                  fields: item?.compProps?.attributeForm?.fields?.map(
                    (_item: any) => {
                      if (_item?.compProps?.id === 'city') {
                        return {
                          ..._item,
                          compProps: {
                            ..._item?.compProps,
                            options: _response?.cities,
                          },
                        };
                      }
                      return { ..._item };
                    }
                  ),
                },
                // options: _response?.cities,
              },
            };
          }
          if (id === 'parish' && item?.compProps?.id === 'city') {
            console.log('reached-->', item?.compProps?.id);

            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'selfParish' &&
            item?.compProps?.id === 'selfCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'employedParish' &&
            item?.compProps?.id === 'employedCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          }
          // } else if (
          //   id === 'employerParishDep' &&
          //   item?.compProps?.id === 'employerCityDep'
          // ) {
          //   return {
          //     ...item,
          //     compProps: {
          //       ...item?.compProps,
          //       options: _response?.cities,
          //     },
          //   };
          // }
          else {
            return {
              ...item,
            };
          }
        });
        // setFormFields(_fields);
        return _fields;
        console.log(`8-> :: #3 ;ertertetetert`, _fields);
      }
    }
  };

  console.log(
    'iobm->',
    formFields
    // ?.filter((item: any) => item?.compProps?.id === 'qualification')
  );

  const tempData: any = {
    first: 1,
    second: 2,
  };
  console.log('uio->', initialData);

  const _checkLayout = (layoutData: any[], key: string, action: string) => {
    console.log(`updateInitialData : _checkLayout :`, key, initialData);

    let _res: any[] = [];
    if (action === 'delete') {
      layoutData.length > 0 &&
        layoutData.map((item: any) => {
          if (item?.length > 0 && item[0] !== key) {
            _res.push(item);
            console.log(
              `updateInitialData : _checkLayout :`,
              item,
              key,
              initialData?.[key]
            );
          }
        });
    } else if (action === 'add') {
      let isExist: boolean = false;
      layoutData.length > 0 &&
        layoutData.map((item: any) => {
          if (item?.length > 0 && item[0] === key) {
            isExist = true;
          }
        });
      if (isExist) {
        _res = layoutData;
      } else {
        _res = layoutData;
        _res.push([key]);
      }
    }
    return _res;
  };

  console.log(`8-> :: #3 ;`, formFields);

  const dynamicItems = [
    { id: 'maritalStatus', payload: 'married', newItem: 'marriage' },
    { id: 'maritalStatus', payload: 'divorced', newItem: 'divorce' },
  ];

  console.log('initu->', initialData);

  const updateInitialData = async (id: any, payload: any) => {
    console.log(`updateInitialData :`, id, payload, initialData);
    let _layout: any = stateLayout;
    let isRemove = false;
    let _fields: any = [];
    console.log('typo->', type);
    setinitialData({ ...initialData, [id]: payload });

    // if (id === 'maritalStatus') {
    //   console.log('typo->', type);

    //   let _fields: any = formFields.map((item: any, index: number) => {
    //     if (item?.compProps?.id === 'nameChangeType') {
    //       const oldOptions = item?.compProps?.options?.filter(
    //         (_item: any) => _item?.id !== '2' && _item?.id !== '3'
    //       );
    //       const currItem =
    //         payload === 'married'
    //           ? [
    //               {
    //                 label: 'Marriage Certificate',
    //                 id: '2',
    //               },
    //             ]
    //           : payload === 'divorced'
    //           ? [
    //               {
    //                 label: 'Decree Absolute (Divorce)',
    //                 id: '3',
    //               },
    //             ]
    //           : [];
    //       return {
    //         ...item,
    //         compProps: {
    //           ...item?.compProps,
    //           options: [...currItem, ...oldOptions],
    //         },
    //       };
    //     }
    //     return { ...item };
    //   });
    //   console.log('reached-->', _fields);

    //   setFormFields(_fields);
    // } else if (
    //   id === 'parish' ||
    //   id === 'selfParish' ||
    //   id === 'employedParish' ||
    //   payload?.id === 'qualification'
    // ) {
    //   //onParishChange && onParishChange({ ...initialData, [id]: payload });
    //   const actualPayload = payload?.payload ?? payload;
    //   const _response = await getSrv().agent.getCities(actualPayload);
    //   console.log(`response from parish ::`, _response);
    //   if (_response) {
    //     console.log(`8-> :: #3 ;`, formFields);

    //     let _fields: any = formFields.map((item: any, index: number) => {
    //       console.log('86->', payload, item, _response.cities);
    //       if (
    //         payload?.id === 'qualification' &&
    //         payload?.subId === 'parish' &&
    //         item?.compProps?.id === 'qualification'
    //       ) {
    //         console.log('86->hi->', item);
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             attributeForm: {
    //               ...item?.compProps?.attributeForm,
    //               fields: item?.compProps?.attributeForm?.fields?.map(
    //                 (_item: any) => {
    //                   if (_item?.compProps?.id === 'city') {
    //                     return {
    //                       ..._item,
    //                       compProps: {
    //                         ..._item?.compProps,
    //                         options: _response?.cities,
    //                       },
    //                     };
    //                   }
    //                   return { ..._item };
    //                 }
    //               ),
    //             },
    //             // options: _response?.cities,
    //           },
    //         };
    //       }
    //       if (id === 'parish' && item?.compProps?.id === 'city') {
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             options: _response?.cities,
    //           },
    //         };
    //       } else if (
    //         id === 'selfParish' &&
    //         item?.compProps?.id === 'selfCity'
    //       ) {
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             options: _response?.cities,
    //           },
    //         };
    //       } else if (
    //         id === 'employedParish' &&
    //         item?.compProps?.id === 'employedCity'
    //       ) {
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             options: _response?.cities,
    //           },
    //         };
    //       }
    //       // } else if (
    //       //   id === 'employerParishDep' &&
    //       //   item?.compProps?.id === 'employerCityDep'
    //       // ) {
    //       //   return {
    //       //     ...item,
    //       //     compProps: {
    //       //       ...item?.compProps,
    //       //       options: _response?.cities,
    //       //     },
    //       //   };
    //       // }
    //       else {
    //         return {
    //           ...item,
    //         };
    //       }
    //     });

    //     setFormFields(_fields);
    //     console.log(`8-> :: #3 ;`, _fields);
    //   }
    // }

    // console.log('lty->', isRemove, id, initialData?.[id]);
    // setStateLayout(_layout);
    // if (isRemove) {
    // } else if (initialData?.[id] !== payload) {
    //   console.log('reacted->');
    //   // setinitialData({ ...initialData, [id]: payload });
    // }
  };

  // useEffect(() => {
  //   console.log('matik->', activeStep);
  // });

  const _renderRightContainer = () => {
    return (
      <RightContainer rightBlockContent={rightBlockContent?.userInviteInfo} />
    );
  };

  const _renderBody = () => {
    console.log('pk->', initialData);
    if (activeStep == 1 && whoami === 'owner') {
      const profileData = {
        navItems: Object.entries(layout[1])?.map((_item: any) => {
          console.log('layout--renew--item', _item);
          return {
            key: _item[0],
            title: <>{_item[1]?.label}</>,
            link: `/${_item[0]}`,
            type: 'navbar',
          };
        }),
      };
      console.log('layout--roe--profile', { ...profileData });
      return (
        <>
          {_renderHeader(true)}{' '}
          <FontSlider fontScale={fontScale} updateFontScale={updateFontScale} />
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '80%' }}>
              <div className="bg-white rounded tweety-form-shadow">
                <ChannelPage
                  {...profileData}
                  fontScale={fontScale}
                  activeKey={'first'}
                  isNoProfileExist={true}
                  onNavItemClick={(key: string) => {
                    changeTouchStatus(initialData, key);
                    setTempkey(key);
                  }}
                />
                <TweetyWidget
                  key={'qq'}
                  fontScale={fontScale}
                  fields={formFields}
                  initialData={initialData}
                  validatorConfig={validatorConfig}
                  layout={formlayout?.first?.data}
                  onChange={(id, payload) => updateInitialData(id, payload)}
                  onFormSubmit={(payload?: any) => {
                    setinitialData({ ...initialData, ...payload });
                    setActiveStep((act: any) => act + 1);
                    // onNewroeNext &&
                    //   onNewroeNext({
                    //     ...initialData,
                    //     type: 'CARICOM_NEW_WORK_PERMIT',
                    //   });
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (activeStep === 2 && whoami === 'owner') {
      console.log('userFormFields', userFormFields, userFormLayout);
      const userInitialData = {
        firstName: initialData?.firstName,
        lastName: initialData?.lastName,
        userEmail: initialData?.userEmail,
      };
      return (
        <>
          <div
            style={{ ...S.UserFormTitleStyle, textAlign: 'center' }}
            className="mt-2"
          >
            {userFormTitle}
          </div>
          <Row
            style={{ justifyContent: 'center', display: 'flex' }}
            className="bg-white rounded mt-3 tweety-form-shadow"
          >
            <Col lg={6} md={7} sm={12} style={{ padding: '20px' }}>
              <TweetyWidget
                key={'proceedToInviteUserForm'}
                labelColor={'#104382'}
                fields={userFormFields}
                layout={userFormLayout}
                // validatorConfig={userValidatorConfig}
                submitButtonLabel="Next"
                initialData={{ ...userInitialData }}
                renderSubmitButton={_renderSubmitButton}
                onFormSubmit={(payload: any) => {
                  // console.log('payload', payload);
                  // setroestep && setroestep((act:any)=>act+1)
                  setActiveStep((act: any) => act + 1);
                  if (applicantbool) {
                    onContinueClick && onContinueClick();
                    setinitialData({ ...initialData, ...payload });
                    stepChange &&
                      stepChange(activeStep + 1, {
                        ...initialData,
                        ...payload,
                      });
                  }
                  if (invitebool) {
                    let data: any = {};
                    fields?.map((item: any) => {
                      console.log('dat->before', item);
                      data[item?.compProps?.id] = undefined;
                    });
                    console.log('dat->', data);
                    setinitialData({ ...initialData, ...data });
                    console.log('dat->', { ...initialData, ...data });
                    stepChange &&
                      stepChange(activeStep + 1, {
                        ...initialData,
                        ...data,
                        ...payload,
                      });
                    onProceedToInvite && onProceedToInvite();
                    console.log('ramsteps->to--->check');
                    setActiveStep(totalSteps);
                  }
                  onUserDetailsSubmit &&
                    onUserDetailsSubmit({
                      ...payload,
                      invite: proceedToInvite,
                    });
                }}
              />
            </Col>
            {_renderRightContainer()}
          </Row>
        </>
      );
    }
    if (activeStep === totsteps) {
      return (
        <>
          {_renderHeader(true)}

          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData(fields, initialData)}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {
              console.log('lk->', initialData);
              onAcknowledgement && onAcknowledgement(initialData, type);
              // setActiveStep(act=>act+1)
            }}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            whoAmI={whoami}
            // onItemClick={(itemId: string) => window.alert(itemId)}
          />
        </>
      );
    }
    if (activeStep === totsteps + 1) {
      return (
        <Acknowledgement
          {...acknowledgement}
          onPayClick={onPayClick}
          applicationNo={applicationNo}
          submitBtnText={
            type === 'CSME_VERIFICATION' || type === 'CARICOM_NEW_WORK_PERMIT'
              ? ''
              : acknowledgement?.submitBtnText ?? ''
          }
        />
      );
    }
    if (
      (activeStep < totsteps && whoami === 'owner') ||
      (whoami !== 'owner' && activeStep < totsteps)
    ) {
      console.log('hoactive->', activeStep, totalSteps, touched, stepHasError);

      const profileData = {
        navItems: Object.entries(layout[0])?.map((_item: any) => {
          return {
            key: _item[0],
            // title: `${stepHasError[`${activeStep}-${_item[0]}`]} ${_item[1]?.label}`,
            title: (
              <>
                {stepHasError[`${activeStep}-${_item[0]}`] === true && (
                  /* @ts-ignore */
                  <S.Img src={errorIcon} fontScale={fontScale} />
                )}
                {(stepHasError[`${activeStep}-${_item[0]}`] === false ||
                  (stepHasError[`${activeStep}-${_item[0]}`] === undefined &&
                    touched[`${activeStep}-${_item[0]}`])) && (
                  /* @ts-ignore */
                  <S.Img src={successIcon} fontScale={fontScale} />
                )}
                {_item[1]?.label}
              </>
            ),
            link: `/${_item[0]}`,
            type: 'navbar',
          };
        }),
      };
      console.log(
        `updateInitialData formFields: `,
        formFields,
        '\nstateLayout : ',
        stateLayout
      );
      console.log('kj1->layout', layout[0]?.[tempKey]?.data, tempKey);
      return (
        <>
          {_renderHeader(true)}
          <FontSlider fontScale={fontScale} updateFontScale={updateFontScale} />

          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '80%' }}>
              <div className="bg-white rounded tweety-form-shadow">
                {/* @ts-ignore */}
                <ChannelPage
                  {...profileData}
                  activeKey={dynamicKey}
                  isNoProfileExist={true}
                  fontScale={fontScale}
                  onNavItemClick={(key: string) => {
                    changeTouchStatus(initialData, key);
                  }}
                />
                <TweetyWidget
                  labelColor={'#104382'}
                  fontScale={fontScale}
                  fields={formFields}
                  cityCall={cityCall}
                  key={`${0}-${dynamicKey}`}
                  touchedStatus={!!touched[`${activeStep}-${dynamicKey}`]}
                  onChange={(id, payload) => updateInitialData(id, payload)}
                  onErrorFree={() => {
                    if (
                      stepHasError[`${activeStep}-${dynamicKey}`] ||
                      stepHasError[`${activeStep}-${dynamicKey}`] === undefined
                    ) {
                      setStepHasError({
                        ...stepHasError,
                        [`${activeStep}-${dynamicKey}`]: false,
                      });
                    }
                  }}
                  onHandleError={(val) => {
                    console.log('ki->');
                    setStepHasError({
                      ...stepHasError,
                      [`${activeStep}-${dynamicKey}`]: val,
                    });
                  }}
                  initialData={initialData}
                  allTouched={touched}
                  lookUpFields={lookUpFields}
                  updateLookUpFields={(data: any) => setLookUpFields(data)}
                  layout={layout[0]?.[tempKey || 'first']?.data}
                  dynamicLayout={dynamicLayout}
                  // onChange={(payload) =>console.log('po->',payload)}
                  onUpdateDynamicLayData={(data: any) =>
                    setinitialData({ ...initialData, ...data })
                  }
                  renderSaveButton={rendersave ? false : true}
                  validatorConfig={validatorConfig}
                  onFormSubmit={(payload: any) => {
                    // const formData = { ...initialData, ...payload };
                    // setinitialData({ ...formData });
                    console.log('intu->', initialData, payload);
                    onDraftSave &&
                      onDraftSave({
                        ...initialData,
                        type: 'CARICOM_NEW_WORK_PERMIT',
                      });
                    console.log(`testing bla ::`, activeStep, totalSteps);
                    if (
                      Object.entries(layout[0])?.length === tempData[dynamicKey]
                    ) {
                      console.log(touched, 'ho->');
                      if (activeStep === totsteps - 1) {
                        const allTouched = Object.entries(touched)?.filter(
                          (item) => !!item[1]
                        );
                        const allErrors = Object.entries(stepHasError)?.filter(
                          (item) => item[1]
                        );
                        let newTouched: any = {};
                        const total = Object.entries(layout[0])?.length;
                        console.log(
                          'ho->so',
                          allTouched,
                          allErrors,
                          total -
                            (stepHasError[`${activeStep}-${dynamicKey}`]
                              ? 1
                              : 0),
                          allTouched.length,
                          total,
                          total -
                            (touched[`${activeStep}-${dynamicKey}`] ? 0 : 1)
                        );
                        if (
                          allErrors?.length ===
                            (stepHasError[`${activeStep}-${dynamicKey}`]
                              ? 1
                              : 0) &&
                          allTouched.length ===
                            total -
                              (touched[`${activeStep}-${dynamicKey}`] ? 0 : 1)
                        ) {
                          Object.entries(layout[0])?.forEach((item, key) => {
                            newTouched[`${activeStep}-${item[0]}`] = true;
                          });
                          _changeTouchStatus && _changeTouchStatus(newTouched);
                          setTouched({ ...newTouched });
                          settempKey('first');
                          changeStepHasError &&
                            changeStepHasError({
                              ...stepHasError,
                              [`${activeStep}-${dynamicKey}`]: false,
                            });
                          onFormSubmit && onFormSubmit(initialData);
                          stepChange && stepChange(activeStep + 1, initialData);
                          setActiveStep((activeStep) => activeStep + 1);
                        } else {
                          console.log('ho->');
                          let newTouched: any = {};
                          let err: any = {};
                          Object.entries(layout[0])?.forEach((item, key) => {
                            newTouched[`${activeStep}-${item[0]}`] = true;
                            if (!touched[`${activeStep}-${item[0]}`]) {
                              if (
                                key ===
                                Object.entries(layout[0])?.length - 1
                              ) {
                                err[`${activeStep}-${item[0]}`] = false;
                              } else {
                                err[`${activeStep}-${item[0]}`] = true;
                              }
                            }
                          });
                          setTouched(newTouched);
                          // console.log('ho->',stepHasError,err,{...stepHasError,...err});
                          setStepHasError({ ...stepHasError, ...err });
                          settempKey('first');
                          window.scrollTo(0, 0);
                        }
                        if (
                          activeStep == 3 &&
                          dynamicKey == 'third' &&
                          tempKey == 'third'
                        ) {
                          setActiveStep(4);
                          _changeCurrStep && _changeCurrStep(4);
                          // setCurrentStep(currentStep+1);
                          settempKey((tempKey) => tempKey + 1);
                        }
                      } else {
                        if (
                          activeStep == 3 &&
                          dynamicKey == 'third' &&
                          tempKey == 'third'
                        ) {
                          setActiveStep(4);
                          _changeCurrStep && _changeCurrStep(4);
                          settempKey((tempKey) => tempKey + 1);
                        } else setActiveStep((activeStep) => activeStep + 1);
                        stepChange &&
                          stepChange(activeStep + 1, { ...initialData });
                        console.log('ho->');
                      }
                      //onNewWorkPermitNext && onNewWorkPermitNext(payload);
                    } else {
                      const ans = Object.entries(layout[0])?.map(
                        (_item) => _item?.[0]
                      );
                      const key = ans.indexOf(dynamicKey);
                      const temp = Object.entries(layout[0])?.[key + 1]?.[0];
                      setStepHasError({
                        ...stepHasError,
                        [`${activeStep}-${dynamicKey}`]: false,
                      });
                      changeTouchStatus(initialData, temp);
                      console.log('ho->');
                      window.scroll(0, 0);
                    }
                  }}
                  submitButtonLabel={'Next'}
                  onDraftSave={(data) =>
                    onDraftSave &&
                    onDraftSave(
                      {
                        ...initialData,
                        type: 'CARICOM_NEW_WORK_PERMIT',
                      },
                      true
                    )
                  }
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  };
  if (spinner?.show) {
    return <Loader {...loading} />;
  }
  return <>{_renderBody()}</>;
};

RoeWPForm.defaultProps = {
  loading: {
    image: '',
    titleNormalText: 'Submitting application',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  csmePreviewSubLabel1: 'Confirm  Details',
  csmePreviewSubLabel2: 'Confirm  Details',
};
